import { ButtonExcelForQuick } from 'components/DownloadExel'
import { Undo2 } from 'lucide-react'

import React from 'react'


const Heading = ({ title, download = "", handleBack = () => { } }) => {


    return (
        <div className="contentHead">
            <h4>{title}</h4>
            {title == "Create Trip" && <button className="rounded-icon-button" onClick={handleBack}>
                <Undo2 size={20} className="rotate-icon" />
            </button>}
        </div>
    )
}

export default Heading